import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export type State =
  | 'AL'
  | 'AK'
  | 'AZ'
  | 'AR'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DE'
  | 'FL'
  | 'GA'
  | 'HI'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'IA'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'ME'
  | 'MD'
  | 'MA'
  | 'MI'
  | 'MN'
  | 'MS'
  | 'MO'
  | 'MT'
  | 'NE'
  | 'NV'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NY'
  | 'NC'
  | 'ND'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VT'
  | 'VA'
  | 'WA'
  | 'WV'
  | 'WI'
  | 'WY'
  | 'DC'
  | 'PR'
  | 'VI'

export const statesMap: Record<State, MapItem> = {
  AL: { label: 'Alabama' },
  AK: { label: 'Alaska' },
  AZ: { label: 'Arizona' },
  AR: { label: 'Arkansas' },
  CA: { label: 'California' },
  CO: { label: 'Colorado' },
  CT: { label: 'Connecticut' },
  DE: { label: 'Delaware' },
  FL: { label: 'Florida' },
  GA: { label: 'Georgia' },
  HI: { label: 'Hawaii' },
  ID: { label: 'Idaho' },
  IL: { label: 'Illinois' },
  IN: { label: 'Indiana' },
  IA: { label: 'Iowa' },
  KS: { label: 'Kansas' },
  KY: { label: 'Kentucky' },
  LA: { label: 'Louisiana' },
  ME: { label: 'Maine' },
  MD: { label: 'Maryland' },
  MA: { label: 'Massachusetts' },
  MI: { label: 'Michigan' },
  MN: { label: 'Minnesota' },
  MS: { label: 'Mississippi' },
  MO: { label: 'Missouri' },
  MT: { label: 'Montana' },
  NE: { label: 'Nebraska' },
  NV: { label: 'Nevada' },
  NH: { label: 'New Hampshire' },
  NJ: { label: 'New Jersey' },
  NM: { label: 'New Mexico' },
  NY: { label: 'New York' },
  NC: { label: 'North Carolina' },
  ND: { label: 'North Dakota' },
  OH: { label: 'Ohio' },
  OK: { label: 'Oklahoma' },
  OR: { label: 'Oregon' },
  PA: { label: 'Pennsylvania' },
  RI: { label: 'Rhode Island' },
  SC: { label: 'South Carolina' },
  SD: { label: 'South Dakota' },
  TN: { label: 'Tennessee' },
  TX: { label: 'Texas' },
  UT: { label: 'Utah' },
  VT: { label: 'Vermont' },
  VA: { label: 'Virginia' },
  WA: { label: 'Washington' },
  WV: { label: 'West Virginia' },
  WI: { label: 'Wisconsin' },
  WY: { label: 'Wyoming' },
  DC: { label: 'District Of Columbia' },
  PR: { label: 'Puerto Rico' },
  VI: { label: 'Virgin Islands' },
}

export const statesSchema = z.enum(Object.keys(statesMap) as [State, ...State[]])
